import { useState } from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from "@chakra-ui/react";
import { Modal } from "../Modal";

// Import the two modals' content (converted into components)
import CreateOrEditMetricComponent from './PerformanceMetric';
import BlackFundImpactMetricForm from "./BlackFundImpactMetric";
import { Metric } from "../../../../redux/reducers/types";

const TabbedMetricsModal = ({
  isOpen,
  onClose,
  goalId,
  orgId,
  sparkId,
  metric,
  isBlackFundGrantee = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  goalId: string;
  orgId: string;
  sparkId: string | number | undefined;
  metric?: Metric;
  isBlackFundGrantee?: boolean;
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={"Create Metrics"}
      // NOTE: Buttons are controlled from inside each tab, not here
// We hide modal footer — each tab form controls its own buttons
    >
      <Box>
        <Tabs index={tabIndex} onChange={(i) => setTabIndex(i)}>
          <TabList>
            <Tab fontWeight="bold">Performance Metrics</Tab>
            {isBlackFundGrantee && (
              <Tab fontWeight="bold">Black Fund Metrics</Tab>
            )}
          </TabList>

          <TabPanels mt={4}>
            <TabPanel px={0}>
              <CreateOrEditMetricComponent
                goalId={goalId}
                orgId={orgId}
                sparkId={sparkId}
                metric={metric}
                onClose={onClose}
              />
            </TabPanel>

            {isBlackFundGrantee && (
              <TabPanel px={0}>
                <BlackFundImpactMetricForm
                  orgId={orgId}
                  goalId={goalId}
                  onClose={onClose}
                />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </Box>
    </Modal>
  );
};

export default TabbedMetricsModal;
